import { useTranslation } from 'react-i18next';

import { useTenantConfig } from '../tenant-config-module/use-tenant-config.js';

/**
 * Dezenter Footer-Link auf das Impressum des Mandanten.
 *
 * Liegt statisch unterhalb des Screen-Bereichs in der `AppShell` und ist
 * dadurch auf allen Screens (Start, Loading, Result, Error) sichtbar. Das Ziel
 * ist `config.imprintUrl` — eine vom Mandanten gepflegte externe Seite; daher
 * öffnet der Link in einem neuen Tab (`rel="noopener noreferrer"`).
 *
 * `imprintUrl` ist optional: Fehlt das Feld, rendert die Komponente `null`,
 * damit Mandanten ohne hinterlegtes Impressum betriebsfähig bleiben.
 */
export function ImprintFooter(): JSX.Element | null {
  const { t } = useTranslation();
  const config = useTenantConfig();
  if (config.imprintUrl === undefined) {
    return null;
  }
  return (
    <footer className="px-6 pb-4 pt-2 text-right">
      <a
        href={config.imprintUrl}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={t('app.imprintAriaLabel')}
        data-testid="imprint-link"
        className="text-xs text-foreground/50 underline-offset-2 transition-colors hover:text-foreground/80 hover:underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand"
      >
        {t('app.imprintLabel')}
      </a>
    </footer>
  );
}
